import type { PriceForProductDto } from '@/api';
import { getApiClient } from '@/api/client';
import { useQuery } from '@tanstack/react-query';

export const usePriceForProduct = (
  productId: number | null,
  priceUnitId: number | null,
) =>
  useQuery({
    queryKey: ['priceForProduct', productId, priceUnitId],
    queryFn: async (): Promise<PriceForProductDto[]> => {
      if (productId == null || priceUnitId == null) {
        return [];
      }
      const response = await getApiClient().pricesForProduct({
        productId,
        priceUnitId,
      });
      return response ?? [];
    },
    enabled: productId != null && priceUnitId != null,
  });
